module.exports = __webpack_public_path__ + "img/NL.732d6287.svg";